import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'themeLabel'
})
export class ThemeLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (value === 'D') return 'Dark';
    if (value === 'L') return 'Light';
    return value;
  }
}